import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "fw-bold mb-3" };
const _hoisted_2 = { class: "rounded bg-white p-3" };
const _hoisted_3 = { class: "mb-3" };
const _hoisted_4 = { class: "form-check mb-3" };
const _hoisted_5 = { class: "form-floating mb-3" };
import TenantLayout from '@/Tenant/Layouts/TenantLayout.vue';
import { Head, useForm } from '@inertiajs/vue3';
import { onMounted, ref } from 'vue';
import { responseMessages } from '@/Composables/responseMessages';
import axios from 'axios';
import ProductPriceTable from '@/Tenant/Components/ProductPriceTable.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Edit',
    props: {
        priceBundle: Object
    },
    setup(__props) {
        let { showPageFlashMessage, showErrorMessage, showSuccessMessage } = responseMessages();
        const props = __props;
        const editBundleForm = useForm({
            name: props.priceBundle?.name,
            active: props.priceBundle ? props.priceBundle.active : false
        });
        const prices = ref([]);
        onMounted(() => {
            loadPrices();
        });
        function loadPrices() {
            if (props.priceBundle == null) {
                return;
            }
            axios.post(route('admin.priceBundles.prices.load', props.priceBundle.uuid)).then((response) => {
                prices.value = response.data;
            }).catch((error) => {
                showErrorMessage(error);
            });
        }
        function updateBundle() {
            if (props.priceBundle == null) {
                return;
            }
            editBundleForm.submit('put', route('admin.priceBundles.update', props.priceBundle.uuid), {
                preserveScroll: true,
                onSuccess: page => {
                    showPageFlashMessage(page);
                },
                onError: errors => {
                    console.log(errors);
                    showErrorMessage(errors[0]);
                }
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(_unref(Head), { title: "Preis-Bundle-Details" }),
                _createVNode(TenantLayout, null, {
                    default: _withCtx(() => [
                        _createElementVNode("h1", _hoisted_1, "Preis-Bundle: " + _toDisplayString(props.priceBundle.name), 1),
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("form", {
                                    onSubmit: _withModifiers(updateBundle, ["prevent"])
                                }, [
                                    _createElementVNode("div", _hoisted_4, [
                                        _withDirectives(_createElementVNode("input", {
                                            class: "form-check-input",
                                            type: "checkbox",
                                            value: "1",
                                            id: "priceBundleActive",
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_unref(editBundleForm).active) = $event))
                                        }, null, 512), [
                                            [_vModelCheckbox, _unref(editBundleForm).active]
                                        ]),
                                        _cache[2] || (_cache[2] = _createElementVNode("label", {
                                            class: "form-check-label",
                                            for: "priceBundleActive"
                                        }, "Aktiv", -1))
                                    ]),
                                    _createElementVNode("div", _hoisted_5, [
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "form-control",
                                            id: "priceBundleName",
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_unref(editBundleForm).name) = $event))
                                        }, null, 512), [
                                            [_vModelText, _unref(editBundleForm).name]
                                        ]),
                                        _cache[3] || (_cache[3] = _createElementVNode("label", { for: "priceBundleName" }, "Name", -1))
                                    ]),
                                    _cache[4] || (_cache[4] = _createElementVNode("button", {
                                        type: "submit",
                                        class: "btn btn-success d-inline-flex align-items-center"
                                    }, [
                                        _createElementVNode("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "16",
                                            height: "16",
                                            fill: "currentColor",
                                            class: "bi bi-check2",
                                            viewBox: "0 0 16 16"
                                        }, [
                                            _createElementVNode("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" })
                                        ]),
                                        _createElementVNode("span", { class: "ms-2" }, "Speichern")
                                    ], -1))
                                ], 32)
                            ]),
                            _createVNode(ProductPriceTable, {
                                priceBundleUuid: props.priceBundle.uuid
                            }, null, 8, ["priceBundleUuid"])
                        ])
                    ]),
                    _: 1
                })
            ], 64));
        };
    }
});
